<div class="quests-container">
  <!-- Header Section with Date Range and Search -->
  <div class="quests-header">
    <div class="date-range-section">
      <mat-form-field>
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="pickerMindfulness">
          <input matStartDate placeholder="Start date" [(ngModel)]="previousDateMindfulness" #dateRangeStartMindfulness>
          <input matEndDate placeholder="End date" [(ngModel)]="currentDateMindfulness" #dateRangeEndMindfulness
            (dateChange)="filterByDateMindfulness(dateRangeStartMindfulness, dateRangeEndMindfulness)">
        </mat-date-range-input>
        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="pickerMindfulness"></mat-datepicker-toggle>
        <mat-date-range-picker #pickerMindfulness></mat-date-range-picker>
      </mat-form-field>
    </div>

    <div class="filters-section">
      <div class="filter-buttons">
        <button class="filter-btn" [class.active]="statusFilter === 'all'" (click)="filterByStatus('all')">
          All Sessions
        </button>
        <button class="filter-btn" [class.active]="statusFilter === 'in-progress'"
          (click)="filterByStatus('in-progress')">
          In-Progress
        </button>
        <button class="filter-btn" [class.active]="statusFilter === 'completed'" (click)="filterByStatus('completed')">
          Completed
        </button>
      </div>
    </div>

    <div class="search-section">
      <input type="text" class="search-input" placeholder="Search Mindfulness Sessions" [(ngModel)]="searchQuery"
        (input)="searchMindfulness()" />
      <span class="search-icon">🔍</span>
    </div>
  </div>

  <!-- Loading State -->
  <div class="loading-state" *ngIf="isLoading">
    <p>Loading meditation data...</p>
  </div>

  <!-- Mindfulness Cards List -->
  <div class="quests-list" *ngIf="!isLoading && hasCards()">
    <div *ngFor="let card of filteredMindfulnessCards; let i = index" class="quest-card"
      [class.expanded]="isCardExpanded(i)">

      <!-- Card Header (Collapsed View) -->
      <div class="quest-header" (click)="toggleCardExpansion(i)">
        <div class="quest-header-content">
          <img [src]="getQuestThumbnail()" alt="Mindfulness thumbnail" class="quest-thumbnail">
          <div class="quest-info">
            <h3 class="quest-name">{{ getQuestName() }}</h3>
            <p class="quest-description">{{ getQuestDescription() }}</p>
          </div>
        </div>
        <div class="quest-meta">
          <div class="quest-status-line">
            <span class="quest-started-date">Started Date: {{ formatDate(card.startDate) }}</span>
            <span class="quest-completed-date" *ngIf="card.isCompleted && card.completedDate">
              Completed On: {{ formatDate(card.completedDate) }}
            </span>
            <span class="quest-status-badge" [class.status-completed]="getCardStatus(card) === 'Completed'"
              [class.status-in-progress]="getCardStatus(card) === 'In-Progress'">
              {{ getCardStatus(card) }}
            </span>
          </div>
          <mat-icon class="expand-icon">{{ isCardExpanded(i) ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
            }}</mat-icon>
        </div>
      </div>

      <!-- Card Body (Expanded View) -->
      <div class="quest-body" *ngIf="isCardExpanded(i)">
        <!-- Sessions Grid -->
        <div class="sessions-grid">
          <!-- Session Cards -->
          <div *ngFor="let session of card.sessions" class="session-card">
            <img [src]="session.thumbnail" alt="Session thumbnail" class="session-thumbnail">
            <div class="session-content">
              <h4 class="session-title">Session {{ session.sessionNumber }}:</h4>
              <p class="session-description">{{ session.title }}</p>
              <div class="session-footer">
                <span class="session-status-badge" [class.status-completed]="getSessionStatus(session) === 'Completed'"
                  [class.status-not-started]="getSessionStatus(session) === 'Not Started'">
                  {{ getSessionStatus(session) }}
                </span>
                <div class="session-completion-wrapper">
                  <span class="session-completion-date">
                    <ng-container *ngIf="session.completionDate">Completed on <strong>{{
                        formatDate(session.completionDate) }}</strong></ng-container>
                  </span>
                  <!-- Dropdown button for completions -->
                  <div class="completion-dropdown-container" *ngIf="hasCompletions(session)">
                    <button class="dropdown-toggle-btn" (click)="toggleSessionDropdown(session, $event)">
                      <span class="completion-count">{{ session.completions.length }} {{ session.completions.length === 1 ? 'play' : 'plays' }}</span>
                      <mat-icon class="dropdown-arrow">{{ session.showDropdown ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                    </button>
                    <!-- Dropdown list -->
                    <div class="completion-dropdown-list" *ngIf="session.showDropdown">
                      <div class="dropdown-item" *ngFor="let completion of session.completions; let idx = index">
                        <span class="play-number">Play {{ idx + 1 }}</span>
                        <span class="play-time">{{ formatDateTimeForDropdown(completion.createdDateTime) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="!isLoading && !hasCards()">
    <p>No meditation data available for the selected date range.</p>
  </div>
</div>